module.exports = __webpack_public_path__ + "static/media/logo-trackage-vertical.062e2978.svg";